import { render, staticRenderFns } from "./DetalhesEventoRow.vue?vue&type=template&id=39378604&scoped=true"
import script from "./DetalhesEventoRow.vue?vue&type=script&lang=ts"
export * from "./DetalhesEventoRow.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesEventoRow.vue?vue&type=style&index=0&id=39378604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39378604",
  null
  
)

export default component.exports